export const environment = {
  production: false,
  provideAuth0: {
    domain: 'diazar.us.auth0.com',
    clientId: '2WmaYM4F3DX9GndrPeAEPNbPQmTbMVQR',
    authorizationParams: {
      redirect_uri: window.location.origin
    }
  },
  baseURL: '/api',
  usersControlUrl: 'controldeusuarios.qa.diazar.com/user-info',
  firebaseConfig :{
    apiKey: "AIzaSyBIaorKWhEmK_R2c5aGRqzpOapiyknsIGw",
    authDomain: "diazarcontrol-2ac23.firebaseapp.com",
    projectId: "diazarcontrol-2ac23",
    storageBucket: "diazarcontrol-2ac23.firebasestorage.app",
    messagingSenderId: "958696246802",
    appId: "1:958696246802:web:8803234b1ad049ea43d2cb",
    measurementId: "G-FWD3VK91EP"
  }
}